




import {Vue, Component, Prop, Watch, Emit} from 'vue-property-decorator';
import 'flot';

import dataSeries = jquery.flot.dataSeries;
import plotOptions = jquery.flot.plotOptions;

@Component({})
export default class FlotChart extends Vue {
    @Prop({default: () => []}) data!: dataSeries[];
    @Prop({default: () => {}}) options!: plotOptions;
    @Prop({default: '200px'}) height!: string;

    mounted() {
        this.redraw();
    }

    @Watch('data') onDataSourceChanged(data: []) {
        this.redraw();
    }

    private redraw() {
        $.plot($(<HTMLElement>this.$refs['chart']), this.data, this.options);
    }
}
